<template>
    <div class="video-page">
        <div class="title-box">
            <div class="page-title">视频素材管理</div>
            <div class="btn" @click="handleUpload">上传视频</div>
        </div>
        <a-alert v-if="isExpired" type="warning" show-icon class="expire-warning">
            <template slot="message">
                视频套餐已经到期，请联系管理员续费后再使用相关功能
            </template>
        </a-alert>
        <div class="head">
            <div class="label">
                <span>视频套餐数据总览</span>
                <small class="exp-info" v-if="info.expired_at">(套餐有效期至: {{ info.expired_at }})</small>
            </div>
            <div class="info-box">
                <div class="info-item">
                    <div class="circle" :style="{ '--progress': cdnProgress + '%', '--color': '#6670DF' }">
                        <div class="progress">{{ cdnProgress }}%</div>
                    </div>
                    <div class="info">
                        <div class="row">
                            <div class="name">流量使用量(GB)</div>
                        </div>
                        <div class="row">
                            <div class="num">{{ info.cdn_flux_used }}</div>
                            <div class="total">购买流量总量{{ info.cdn_flux_size }}(GB)</div>
                        </div>
                    </div>
                </div>
                <div class="line"></div>
                <div class="info-item">
                    <div class="circle" :style="{ '--progress': storageProgress + '%', '--color': '#6DB14E' }">
                        <div class="progress">{{ storageProgress }}%</div>
                    </div>
                    <div class="info">
                        <div class="row">
                            <div class="name">储存使用量(GB)</div>
                            <!-- <div class="pay cursor">-->
                            <!-- <span>去购买</span>-->
                            <!-- <img src="/assets/images/video/internet-traffic-pay-icon.png">-->
                            <!-- </div>-->
                        </div>
                        <div class="row">
                            <div class="num">{{ info.storage_used }}</div>
                            <div class="total">购买储存总量{{ info.storage_size }}(GB)</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="page-line"></div>
        
        <a-spin type="loading" :spinning="spinning">
            
            <div class="container">
                <div class="video-item" v-for="item in videoList" :key="item.id">
                    
                    <div class="video-thumb" @click="playVideo(item)">
                        <img :src="item.thumb">
                        <div class="video-play-btn"></div>
                    </div>
                    
                    <div class="video-info">
                        
                        <div class="name">{{ item.name }}</div>
                        
                        <div class="info">
                            <div class="info-row">
                                <div class="info-label">视频时长</div>
                                <div class="info-num">{{ videoTime(item) }}</div>
                            </div>
                            <div class="info-row">
                                <div class="info-label">视频大小</div>
                                <div class="info-num">{{ videoSize(item) }}</div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="utils cursor">
                        <img src="/assets/images/video/del.png" @click="delVideo(item)">
                        <img src="/assets/images/video/edit.png" @click="gotoUpload(item)">
                    </div>
                </div>
            </div>
            
            <a-pagination @change="getVideoList" class="mb-4" v-model="pagination.current"
                          :page-size="pagination.pageSize" :total="pagination.total"></a-pagination>
        
        </a-spin>
        <upload-video v-if="showUpload" @uploadSuccess="uploadSuccess" @uploadClose="uploadClose"></upload-video>
        
        <a-modal v-model="showVideoModal" :footer="null" width="800px" destroyOnClose>
            <template v-if="videoInfo">
                
                <div slot="title">{{ videoInfo.name }}</div>
                
                <video style="width: 100%" :src="videoInfo.url" autoplay controls></video>
            
            </template>
        </a-modal>
    
    </div>
</template>

<script>
import api from "@/repo/api";
import moment from "moment/moment";
import UploadVideo from "@/components/UploadVideo.vue";

export default {
    name: "Video",
    components: {
        UploadVideo 
    },
    data() {
        return {
            spinning: false,
            showUpload: false,
            isUpload: false,
            uploadFile: null,
            uploadPercent: 0,
            current: 0,
            subscription: null,
            info: {},
            videoList: [],
            videoInfo: null,
            showVideoModal: false,
            pagination: {
                defaultCurrent: 1,
                current: 1,
                defaultPageSize: 10,
                total: 1,
                pageSize: 15,
                showTotal: (total, range) => {
                    return `当前${range[0]}-${range[1]}，共 ${total} 个会员`;
                },
            },
        }
    },
    mounted() {
        this.getInfo();
        this.getVideoList();
    },
    computed: {
        cdnProgress() {
            return ((this.info.cdn_flux_used / this.info.cdn_flux_size) * 100).toFixed(2)
        },
        storageProgress() {
            return ((this.info.storage_used / this.info.storage_size) * 100).toFixed(2)
        },
        isExpired() {
            if (!this.info.expired_at) return false;
            return moment(this.info.expired_at).isBefore(moment(), 'day');
        },
    },
    methods: {
        getInfo() {
            api.get('/ast-space/info', {}, res => {
                console.log(res);
                if (res.code == 0) {
                    let {cdn_flux_size, cdn_flux_used, storage_size, storage_used, expired_at} = res.data;
                    let info = {
                        cdn_flux_size: (cdn_flux_size / 1024 / 1024 / 1024).toFixed(0),
                        cdn_flux_used: (Math.abs(cdn_flux_used) / 1024 / 1024 / 1024).toFixed(2),
                        storage_size: (storage_size / 1024 / 1024 / 1024).toFixed(0),
                        storage_used: (Math.abs(storage_used) / 1024 / 1024 / 1024).toFixed(2),
                        expired_at
                    }
                    this.info = info;
                }
            })
        },
        getVideoList() {
            this.spinning = true;
            api.get('/ast-space/videos', {
                page: this.pagination.current
            }, res => {
                console.log(res);
                this.spinning = false;
                if (res.code == 0) {
                    
                    this.videoList = res.data.data;
                    
                    this.pagination.current = res.data.current_page;
                    this.pagination.total = res.data.total;
                    this.pagination.pageSize = res.data.per_page;
                    
                }
            })
        },
        videoSize(item) {
            let size = Number(item.size) / 1024 / 1024;
            return size.toFixed(2) + 'M'
        },
        videoTime(item) {
            let seconds = Number(item.info.duration);
            var duration = moment.duration(Number(seconds), 'seconds');
            var h = duration.hours();
            var m = duration.minutes();
            var s = duration.seconds();
            return (h < 10 ? `0${h}` : h) + ':' + (m < 10 ? `0${m}` : m) + ':' + (s < 10 ? `0${s}` : s)
        },
        playVideo(item) {
            this.videoInfo = item;
            this.showVideoModal = true;
        },
        uploadClose() {
            this.showUpload = false;
        },
        uploadSuccess(query) {
            console.log(query);
            this.$loading.hide();
            this.showUpload = false;
            if (query.name.split('.').length > 1) {
                query.name = query.name.split('.')[0];
                this.updateInfo({name: query.name, id: query.id});
            }
            this.$router.push({
                path: '/ast/serve/video/upload',
                query
            })
        },
        updateInfo(params = {}) {
            api.post('/ast-space/update-file-info', params, res => {
                if (res.code == 0) {
                    
                }
            })
        },
        delVideo(item) {
            console.log(item);
            
            this.$loading.show();
            
            api.post('/ast-space/file-occupancy', {id: item.id}).then(res => {
                
                this.$loading.hide();
                
                if (res.code !== 0) return this.$message.data(res)
                
                if (res.data.occupancy) {
                    return this.$message.error(`失败,该视频已经在[${res.data.info}]中使用`)
                }
                
                this.confirm(`确认删除后该视频将永久消失！`).then(() => {
                    
                    this.$loading.show();
                    
                    api.post('/ast-space/delete-file', {id: item.id}, (res) => {
                        
                        this.$message.data(res)
                        this.$loading.hide();
                        
                        if (res.code == 0) {
                            this.getVideoList();
                        }
                    })
                    
                })
                
            })
        },
        confirm(content) {
            return new Promise((resolve) => {
                this.$confirm({
                    title: '提示',
                    content,
                    onOk() {
                        resolve()
                    },
                });
            })
        },
        handleUpload() {
            if (this.isExpired) {
                this.$message.warning('视频套餐已经到期，无法上传视频，请联系管理员续费');
                return;
            }
            this.showUpload = true;
        },
        gotoUpload(item) {
            if (this.isExpired) {
                this.$message.warning('视频套餐已经到期，无法编辑视频，请联系管理员续费');
                return;
            }
            console.log(item);
            
            this.$router.push({
                path: '/ast/serve/video/upload',
                query: item
            })
        }
    }
}
</script>

<style lang="less" scoped>
.upload-box {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    
    .content {
        width: 408px;
        background: #FFFFFF;
        border-radius: 2px;
        padding: 24px;
        position: relative;
        
        .header {
            .close {
                width: 56px;
                height: 56px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 0;
                right: 0;
                
                img {
                    width: 16px;
                    height: 16px;
                }
            }
            
            .label {
                color: #333333;
                font-size: 16px;
                font-weight: bold;
                line-height: 22px;
            }
            
            .line {
                width: 360px;
                height: 1px;
                background: #EEEEEE;
                margin: 16px 0;
            }
        }
        
        .upload {
            width: 360px;
            height: 300px;
            
            .add-video {
                width: 360px;
                height: 300px;
                border-radius: 8px;
                border: 1px dashed #999999;
                display: flex;
                flex-direction: column;
                justify-content: center;
                
                .progress {
                    width: 80%;
                    margin: 32px auto 0;
                }
                
                .text {
                    color: #333333;
                    font-size: 14px;
                    margin-top: 16px;
                    text-align: center;
                }
                
                .btn {
                    width: fit-content;
                    margin: 64px auto 0;
                }
                
                &:hover {
                    border-color: #1890FF;
                }
            }
            
            .add-video-progress {
                &:hover {
                    border: 1px dashed #999999;
                }
            }
        }
        
    }
}

.title-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
    
    .page-title {
        font-weight: bold;
        margin-bottom: 0;
    }
}

.page-line {
    width: 100%;
    height: 1px;
    background: #EEEEEE;
    margin-top: 32px;
    margin-bottom: 24px;
}

.container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 24px;
    
    
    .video-item {
        width: 468px;
        height: 128px;
        background: #FFFFFF;
        border: 1px solid #EEEEEE;
        margin-bottom: 24px;
        padding: 16px;
        display: flex;
        align-items: center;
        position: relative;
        
        .utils {
            position: absolute;
            top: 16px;
            right: 16px;
            
            img {
                width: 24px;
                height: 24px;
                
                &:nth-child(1) {
                    margin-right: 8px;
                }
            }
        }
        
        .video-thumb {
            width: 96px;
            height: 96px;
            margin-right: 16px;
            position: relative;
            
            img {
                width: 96px;
                height: 96px;
                object-fit: cover;
                border: 1px solid #EEEEEE;
            }
        }
        
        .video-info {
            height: 96px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            
            .name {
                color: #333333;
                font-size: 14px;
                font-weight: bold;
                line-height: 20px;
            }
            
            .info {
                display: flex;
                
                .info-row {
                    margin-right: 32px;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    
                    .info-label {
                        color: #999999;
                        font-size: 14px;
                        line-height: 20px;
                    }
                    
                    .info-num {
                        color: #333333;
                        font-size: 16px;
                        font-weight: bold;
                        line-height: 22px;
                        margin-top: 8px;
                    }
                }
            }
            
            
        }
    }
}

.head {
    width: 100%;
    border: 1px solid #EEEEEE;
    
    .label {
        width: 100%;
        height: 54px;
        line-height: 54px;
        border-bottom: 1px solid #EEEEEE;
        color: #333333;
        font-size: 16px;
        font-weight: bold;
        padding: 0 24px;
    }
    
    .info-box {
        width: 100%;
        height: 98px;
        display: flex;
        align-items: center;
        
        .info-item {
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
            padding: 0 24px;
            
            .circle {
                width: 64px;
                height: 64px;
                border-radius: 50%;
                background: conic-gradient(var(--color) 0%, var(--color) var(--progress), rgba(0, 0, 0, 0.04) var(--progress), rgba(0, 0, 0, 0.04) 100%);
                margin-right: 16px;
                position: relative;
                
                .progress {
                    width: 48px;
                    height: 48px;
                    line-height: 48px;
                    border-radius: 50%;
                    text-align: center;
                    background: #fff;
                    position: absolute;
                    top: 8px;
                    left: 8px;
                    color: #333333;
                    font-size: 12px;
                }
            }
            
            .info {
                flex: 1;
                height: 64px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                
                .row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    
                    .name {
                        color: #333333;
                        font-size: 14px;
                        line-height: 20px;
                    }
                    
                    .pay {
                        display: flex;
                        align-items: center;
                        
                        span {
                            color: #FBB03B;
                            font-size: 14px;
                            margin-right: 4px;
                            line-height: 20px;
                        }
                        
                        img {
                            width: 12px;
                            height: 12px;
                        }
                    }
                    
                    .num {
                        color: #333333;
                        font-size: 24px;
                        font-weight: 500;
                        line-height: 24px;
                    }
                    
                    .total {
                        color: #999999;
                        font-size: 14px;
                        line-height: 24px;
                    }
                }
            }
        }
        
        .line {
            width: 1px;
            height: 50px;
            background: #EEEEEE;
            margin: 0 40px;
        }
    }
}

.codes-tool {
    padding-top: 10px;
    justify-content: flex-start;
    font-size: 12px;
    
    a {
        margin-left: 8px;
    }
}

.exp-info {
    font-weight: normal;
    margin-left: 16px;
    opacity: .8;
}

.expire-warning {
    margin-bottom: 16px;
}

.video-play-btn {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.4);
    background-image: url("/assets/icons/video-play-btn.png");
    background-size: auto;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
}
</style>